export default {
    isShowLoading:false,                //控制loading
}   


// WEBPACK FOOTER //
// ./src/store/state.js